import { Texts } from "constants";
import React from "react";
import { useSelector } from "react-redux";
import { MAVENCERY_STORES_NAMES } from "constants";

const LoginInfo = ({ onClick }) => {
  const { selectedStore } = useSelector((store) => store.selectedStore);

  return (
    <div className="w-full space-y-3 h-72 py-auto login-text-container">
      <h4 className="text-3xl font-bold">{Texts.alreadyAccountText}</h4>
      <h5 className="text-2xl font-bold">{Texts.loginText}</h5>
      <p>
        {!selectedStore?.isWhiteLabel
          ? Texts.mavenceryLoginDescriptionText
          : selectedStore?.isWhiteLabel &&
            selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
          ? Texts.alHalalLoginDescriptionText
          : Texts.nisaLocalLoginDescriptionText}
      </p>
      <button
        onClick={onClick}
        className="px-3 py-2 border border-black rounded-md hover:border-gray-600 "
      >
        Login
      </button>
    </div>
  );
};

export default LoginInfo;
